import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' 
})
export class FocusService {
  private previouslyFocusedElement: HTMLElement;

  storeFocusedElement() {
    this.previouslyFocusedElement = document.activeElement as HTMLElement;
  }

  returnFocus() {
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }
}